import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OptionsEventService {
    private optionsEventSubject$: BehaviorSubject<any>;
    public optionsEvent$: Observable<any>;

    constructor(private http: HttpClient) {
        this.optionsEventSubject$ = new BehaviorSubject<any>(null);
        this.optionsEvent$ = this.optionsEventSubject$.asObservable();
    }

    public get optionsEventValue(): any {
        return this.optionsEventSubject$.value;
    }

    setOptionEvent(val) {
        this.optionsEventSubject$.next(val);
    }
}
